var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{attrs:{"toggle-class":"fn-ui-report-range-selector-dropdown","variant":"link","text":_vm.selected.text,"size":"sm"}},_vm._l((_vm.types),function(type){return _c('b-dropdown-item',{key:type.value,on:{"click":() => _vm.handleChange(type.value)}},[_vm._v(_vm._s(type.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }